module.exports = __webpack_public_path__ + "img/web_bottom.37869819.png";